"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.split");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _Button = _interopRequireDefault(require("../Button"));

var _FileInputErrorCode = _interopRequireDefault(require("./FileInputErrorCode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FileInput = /*#__PURE__*/function (_React$Component) {
  _inherits(FileInput, _React$Component);

  var _super = _createSuper(FileInput);

  function FileInput(props) {
    var _this;

    _classCallCheck(this, FileInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleUploadClick", function () {
      if (!_this.dropzone) {
        return;
      }

      _this.dropzone.open();
    });

    _defineProperty(_assertThisInitialized(_this), "handleFilesAccepted", function (acceptedFiles) {
      _this.props.onAcceptFiles(acceptedFiles);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFilesRejected", function (rejectedFiles) {
      _this.props.onRejectFiles(rejectedFiles);
    });

    _defineProperty(_assertThisInitialized(_this), "handleCustomValidate", function (file) {
      var maxLength = _this.props.maxFileNameLength;
      var fileNameWithoutExt = file.name.split('.').slice(0, -1).join('.');

      if (fileNameWithoutExt.length > maxLength) {
        return {
          code: _FileInputErrorCode.default.FILE_NAME_LARGE_CODE,
          message: _FileInputErrorCode.default.FILE_NAME_LARGE_MESSAGE
        };
      }

      return null;
    });

    _this.dropzone = null;
    return _this;
  }

  _createClass(FileInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          instructions = _this$props.instructions,
          btnLabel = _this$props.btnLabel,
          minSizeInBytes = _this$props.minSizeInBytes,
          maxSizeInBytes = _this$props.maxSizeInBytes,
          maxFileNameLength = _this$props.maxFileNameLength,
          supportedFileTypes = _this$props.supportedFileTypes,
          multiple = _this$props.multiple,
          buttonAriaLabel = _this$props.buttonAriaLabel,
          onAcceptFiles = _this$props.onAcceptFiles,
          onRejectFiles = _this$props.onRejectFiles,
          attrs = _objectWithoutProperties(_this$props, ["className", "instructions", "btnLabel", "minSizeInBytes", "maxSizeInBytes", "maxFileNameLength", "supportedFileTypes", "multiple", "buttonAriaLabel", "onAcceptFiles", "onRejectFiles"]);

      var classes = (0, _classnames.default)(className, 'file-input', 'dropzone');
      return /*#__PURE__*/_react.default.createElement(_reactDropzone.default, _extends({
        className: classes,
        onDropAccepted: this.handleFilesAccepted,
        onDropRejected: this.handleFilesRejected,
        validator: this.handleCustomValidate,
        minSize: minSizeInBytes,
        maxSize: maxSizeInBytes,
        noClick: true,
        noKeyboard: true,
        maxFileNameLength: maxFileNameLength,
        activeClassName: "dropzone--active",
        acceptClassName: "dropzone--accept",
        rejectClassName: "dropzone--reject",
        disableClick: true,
        multiple: multiple,
        accept: supportedFileTypes.join(', '),
        ref: function ref(node) {
          _this2.dropzone = node;
        }
      }, attrs), function (_ref) {
        var getRootProps = _ref.getRootProps,
            getInputProps = _ref.getInputProps;
        return /*#__PURE__*/_react.default.createElement("div", getRootProps({
          className: classes
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "file-input__content"
        }, instructions), /*#__PURE__*/_react.default.createElement(_Button.default, {
          className: "file-input__button",
          "aria-label": buttonAriaLabel,
          type: "button",
          tag: "button",
          variant: _Button.default.Variant.PRIMARY,
          onClick: _this2.handleUploadClick
        }, btnLabel, /*#__PURE__*/_react.default.createElement("input", getInputProps())));
      });
    }
  }]);

  return FileInput;
}(_react.default.Component);

FileInput.defaultProps = {
  className: null,
  onAcceptFiles: function onAcceptFiles() {},
  onRejectFiles: function onRejectFiles() {},
  btnLabel: 'Upload',
  instructions: 'Drag and drop or select a file',
  supportedFileTypes: ['.jpg', '.jpeg', '.png', '.bmp', '.tif', '.tiff', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.txt', '.rtf', '.zip', '.rar', '.pdf'],
  minSizeInBytes: 0,
  maxSizeInBytes: Infinity,
  maxFileNameLength: 80,
  multiple: true,
  buttonAriaLabel: null
};
FileInput.propTypes = {
  btnLabel: _propTypes.default.node,
  className: _propTypes.default.string,
  instructions: _propTypes.default.node,
  minSizeInBytes: _propTypes.default.number,
  maxSizeInBytes: _propTypes.default.number,
  maxFileNameLength: _propTypes.default.number,
  supportedFileTypes: _propTypes.default.arrayOf(_propTypes.default.string),
  onAcceptFiles: _propTypes.default.func,
  onRejectFiles: _propTypes.default.func,
  multiple: _propTypes.default.bool,
  buttonAriaLabel: _propTypes.default.string
};
var _default = FileInput;
exports.default = _default;
//# sourceMappingURL=FileInput.js.map